import React, { useContext } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { RootStoreContext } from '../stores/RootStore';
import { StepName } from '../config/Wizard';
import './CampaignsView.css';

const CampaignsView = observer(() => {
  const { eventPhotoStore, wizardStore } = useContext(RootStoreContext);
  const navigate = useNavigate();
  const selectedCampaign = eventPhotoStore.adCampaigns.find(
    campaign => campaign.id === eventPhotoStore.selectedCampaignId
  );

  const selectCampaign = (campaignId: number | null) => {
    eventPhotoStore.selectCampaign(campaignId);
    window.scrollTo({ top: 0 });
  };

  const handleBack = () => {
    if (eventPhotoStore.selectedCampaignId !== null) {
      selectCampaign(null);
      return;
    }

    navigate('/');
    wizardStore.setStep(StepName.REGISTRATION_SELECT_TRAINING);
  };

  return (
    <main className="campaigns-page">
      <div className={`campaigns-toolbar${selectedCampaign ? ' campaigns-toolbar--detail' : ''}`}>
        <button className="secondary-nav-button" type="button" onClick={handleBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
          <span>Back</span>
        </button>
        <h1>{selectedCampaign?.title || "What's New"}</h1>
      </div>

      {selectedCampaign ? (
        <article className="campaign-details-card">
          <div className="campaign-square-image">
            <img src={selectedCampaign.imageUrl} alt={selectedCampaign.title} />
          </div>
          <div className="campaign-details-content">
            <p className="campaign-details-description">{selectedCampaign.description}</p>
            {selectedCampaign.cta?.url && (
              <Button
                as="a"
                href={selectedCampaign.cta.url}
                target="_blank"
                rel="noopener noreferrer"
                className="campaign-details__cta"
              >
                {selectedCampaign.cta.label.trim() || 'View info'}
              </Button>
            )}
          </div>
        </article>
      ) : (
        <section className="campaigns-overview" aria-label="Current campaigns">
          <Row className="g-4">
            {eventPhotoStore.adCampaigns.map(campaign => (
              <Col key={campaign.key} xs={12} md={6}>
                <button
                  type="button"
                  className="campaign-overview-card"
                  data-campaign-id={campaign.id}
                  onClick={() => selectCampaign(campaign.id)}
                >
                  <div className="campaign-square-image">
                    <img src={campaign.imageUrl} alt={campaign.title} />
                  </div>
                  <span>{campaign.title}</span>
                </button>
              </Col>
            ))}
          </Row>
        </section>
      )}
    </main>
  );
});

export default CampaignsView;
